export const HELP_CATEGORIES = [
  { value: 'employment', label: 'Employment' },
  { value: 'medical_info', label: 'Medical information' },
  { value: 'education', label: 'Education and training' },
  { value: 'household', label: 'Household or personal' },
  { value: 'social', label: 'Social programme' },
  { value: 'women', label: 'Women empowerment' },
  { value: 'elders', label: 'Elder support' },
  { value: 'disaster', label: 'Disaster relief' },
  { value: 'other', label: 'Other' },
];

/** Shown under the category when the member is asking a department for help. */
export const DEPARTMENT_HINTS = {
  education: 'Ask for classes, training, or school guidance.',
  women: 'Your Area Head handles this for the Jagat Janani Matru Shakti wing.',
  elders: 'Your Area Head handles this for the Samaj Pathdarshak Vadilvrund wing.',
  disaster: 'Ask for relief help. For a medical or safety emergency, choose Emergency and call 112.',
};

export const EMERGENCY_CATEGORY = 'emergency';

const NEXT_ACTION = {
  New: { status: 'Accepted', label: 'Accept' },
  Accepted: { status: 'In progress', label: 'Mark in progress' },
  'In progress': { status: 'Resolved', label: 'Resolve' },
};

export function helpCategoryLabel(value) {
  const match = HELP_CATEGORIES.find((item) => item.value === value);
  return match ? match.label : value;
}

export function nextHelpAction(status) {
  return NEXT_ACTION[status] || null;
}

export function formatWhen(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatMemberAddress(member) {
  if (!member) return '';
  return [member.street, member.city, member.pincode].filter(Boolean).join(', ');
}
